/* eslint-disable no-debugger, no-console */

// @it-enterprise пакеты
import Localization from '@it-enterprise/localization';
import GrapgQlCore from '@it-enterprise/graphql';

import { inicializeFirebase } from '@/plugins/push-notification';
inicializeFirebase();

import '@/plugins/auth';

import pagePlayerPlugin from '@it-enterprise/page-player';
Vue.use(pagePlayerPlugin, {
  datasources: {},
});

import './plugins/appRunner';

import FeaturesPlugin from '@/plugins/FeaturesPlugin';

// vue пакеты
import Vue from 'vue';
import axios from 'axios';
import { i18n } from './plugins/i18n';
import store from './store';
import App from './App.vue';
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue';
//import VueApexCharts from 'vue-apexcharts'
//import VueTrix from 'vue-trix'
import router from './router';
//import VueTelInput from 'vue-tel-input'

import { apolloProvider } from '@/plugins/apollo';
import layout from '@/layout';
import settings from '@/views/Settings.vue';
import market from '@/views/Market.vue';
//import VueQrcodeReader from 'vue-qrcode-reader'
import VueYoutube from 'vue-youtube';
import { ModelSelect } from 'vue-search-select';
import VueUploadComponent from 'vue-upload-component';
import { Multiselect } from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
//import VueColor from 'vue-color'

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import VueCountdown from '@chenfengyuan/vue-countdown';

import VueClipboards from 'vue-clipboards';

Vue.component('Layout', layout);
Vue.component('Settings', settings);
Vue.component('Market', market);

//Vue.component('apexchart', VueApexCharts)
//Vue.component('vue-trix', VueTrix)
Vue.component('ModelSelect', ModelSelect);
Vue.component('Multiselect', Multiselect);
//Vue.component('vue-color', VueColor)
Vue.component('FileUpload', VueUploadComponent);
Vue.component('VueSlider', VueSlider);
Vue.component(VueCountdown.name, VueCountdown);

Vue.config.ignoredElements = [
  'a-scene',
  'a-camera',
  'a-assets',
  'a-image',
  'a-asset-item',
  'a-entity',
  'a-plane',
  'a-gltf-model',
  'a-sky',
  'a-text',
  'a-box',
];

// объект с зависимостями
let dependencies = {
  i18n,
  apolloProvider,
  axios,
  store,
  router,
};

// Плагины стандартные
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
//Vue.use(VueTelInput)
//Vue.use(VueQrcodeReader)
Vue.use(VueYoutube);
Vue.use(VueClipboards);

// Плагины it-enterprise
Vue.use(GrapgQlCore, { options: window.myConfig, dependencies });
Vue.use(Localization, { dependencies });

//Плагины приложения
Vue.use(FeaturesPlugin, { store });

// импорт компонентов
let req = require.context('@/components/base/', true, /\.(js|vue)$/i);
req.keys().map((key) => {
  if (!(req(key).default || {}).name) {
    return;
  }
  Vue.component(req(key).default.name, req(key).default);
});

// импорт страниц
req = require.context('@/views/', true, /\.(js|vue)$/i);
req.keys().map((key) => {
  if (!(req(key).default || {}).name) {
    return;
  }
  Vue.component(req(key).default.name, req(key).default);
});
let locale = localStorage.getItem('userLocale');
if (!locale || !locale.length || !i18n.availableLocales.includes(locale)) {
  locale = 'en';
}
i18n.locale = locale;

new Vue({
  i18n,
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app');
